import { render, staticRenderFns } from "./OrderTableItem.vue?vue&type=template&id=42222e00&"
import script from "./OrderTableItem.vue?vue&type=script&lang=js&"
export * from "./OrderTableItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports